module.exports = __webpack_public_path__ + "static/media/Institutemgmt.ddc6d919.svg";